export enum EImportStoreActionType {
  DISCONNECT = 'disconnect',
  SYNC = 'sync',
  CREATE = 'create',
}

export const IMPORT_STORE_ACTION_OPTIONS = [
  { label: 'Skip the listing', value: EImportStoreActionType.DISCONNECT },
  { label: 'Link with existing store', value: EImportStoreActionType.SYNC },
  { label: 'Create as a new store', value: EImportStoreActionType.CREATE },
];

export const IMPORTED_STORE_ACTION_OPTIONS = [
  { label: 'Disconnect the listing', value: EImportStoreActionType.DISCONNECT },
  { label: 'Keep link with store', value: EImportStoreActionType.SYNC },
  {
    label: 'Disconnect existing store and link with another one',
    value: EImportStoreActionType.CREATE,
  },
];
